import { render } from "./RevenuVue.vue?vue&type=template&id=632ad0bc&scoped=true"
import script from "./RevenuVue.vue?vue&type=script&lang=js"
export * from "./RevenuVue.vue?vue&type=script&lang=js"

import "./RevenuVue.vue?vue&type=style&index=0&id=632ad0bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632ad0bc"]])

export default __exports__